import React from 'react';
import { object, bool, func } from 'prop-types';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';

import ChevronDown from './ChevronDown';
import ChevronUp from './ChevronUp';
import OlxProKnowMore from './OlxProKnowMore';

const Container = styled.div`
  margin: 12px 16px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const Image = styled.img`
  width: 48px;
  height: 48px;
`;

const TextBox = styled.span`
  margin: 0px 16px;
  width: 224px;
`;

const Title = styled.h3`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  color: #4a4a4a;
`;

const Content = styled.div`
  margin: 16px 16px 16px 64px;
`;

const Description = styled(ReactMarkdown)`
  * {
    font-family: 'Nunito Sans', sans-serif;
    font-size: 16px;
    line-height: 1.5;
    color: #4a4a4a;
  }

  strong {
    font-weight: bold;
  }
`;

const BenefitSection = ({ benefit, open, handleClick }) => (
  <Container>
    <Header onClick={handleClick}>
      <Image src={`${process.env.PUBLIC_URL}/images/${benefit.icon}.svg`} alt={benefit.title} />
      <TextBox>
        <Title>{benefit.title}</Title>
      </TextBox>
      {(open && <ChevronUp />) || <ChevronDown />}
    </Header>
    {open && (
      <Content>
        <Description source={benefit.description} />
        {benefit.olxpro && <OlxProKnowMore />}
      </Content>
    )}
  </Container>
);

export default BenefitSection;

BenefitSection.propTypes = {
  benefit: object.isRequired,
  open: bool.isRequired,
  handleClick: func.isRequired,
};

